import { clients, visits, isDesktop, dataLoading } from '../store/state';
import { Shell } from '../layout/Shell';
import { Kpi } from '../components/Kpi';
import { VisitCard } from '../components/VisitCard';
import { ClientCard } from '../components/ClientCard';
import { VisitsTable } from '../components/VisitsTable';
import { ClientsTable } from '../components/ClientsTable';
import { KpiSkeleton, ListSkeleton } from '../components/Skeleton';
import { Icon } from '../components/Icon';

export function DashboardView() {
  const ven = clients.value.filter((c) => c.estado === 'vencida');
  const pv = clients.value.filter((c) => c.estado === 'por_vencer');
  const ec = visits.value.filter((v) => v.estado === 'en_curso');
  const sinTomar = visits.value.filter((v) => !v.tecnicoId && v.estado === 'agendada');
  const dt = isDesktop.value;

  if (dataLoading.value) {
    return (
      <Shell tab="dashboard">
        <h2 style={{ margin: '0 0 16px' }}>Dashboard</h2>
        <div
          class={dt ? 'kpi-grid' : ''}
          style={dt ? {} : { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 16 }}
        >
          {Array.from({ length: 4 }).map((_, i) => (
            <KpiSkeleton key={i} dt={dt} />
          ))}
        </div>
        <ListSkeleton count={3} />
      </Shell>
    );
  }

  return (
    <Shell tab="dashboard">
      <h2 style={{ margin: '0 0 16px' }}>Dashboard</h2>
      <div
        class={dt ? 'kpi-grid' : ''}
        style={dt ? {} : { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 16 }}
      >
        <Kpi n={ven.length} label="Vencidas" color="--danger" dt={dt} />
        <Kpi n={pv.length} label="Por vencer" color="--warning" dt={dt} />
        <Kpi n={ec.length} label="En curso" color="--primary" dt={dt} />
        <Kpi n={sinTomar.length} label="Sin tomar" color="--text-muted" dt={dt} />
      </div>

      {ven.length === 0 && pv.length === 0 && ec.length === 0 && sinTomar.length === 0 && (
        <div class="empty">
          <Icon name="badge-check" />
          <p>Todo al día. Sin pendientes ni vencimientos.</p>
        </div>
      )}

      {sinTomar.length > 0 && (
        <>
          <h3 style={{ margin: '16px 0 8px' }}>Visitas sin técnico asignado</h3>
          {dt ? <VisitsTable list={sinTomar} /> : sinTomar.map((v) => <VisitCard key={v.id} v={v} />)}
        </>
      )}
      {ven.length > 0 && (
        <>
          <h3 style={{ color: 'var(--danger)', margin: '16px 0 8px' }}>Clientes vencidos</h3>
          {dt ? <ClientsTable list={ven} /> : ven.map((c) => <ClientCard key={c.id} c={c} />)}
        </>
      )}
      {pv.length > 0 && (
        <>
          <h3 style={{ color: 'var(--warning)', margin: '16px 0 8px' }}>Por vencer</h3>
          {dt ? <ClientsTable list={pv} /> : pv.map((c) => <ClientCard key={c.id} c={c} />)}
        </>
      )}
    </Shell>
  );
}
